module.exports = __webpack_public_path__ + "img/github.bb782a68.png";